// API Configuration
// Centralized API base URL configuration for the entire application
// React app is served by Django, so API is always on the same origin.
const API_BASE_URL = typeof window !== 'undefined'
  ? window.location.origin
  : '';

export default API_BASE_URL;
